module.exports = __webpack_public_path__ + "img/logo_hover.8a2dd26b.png";